module.exports = __webpack_public_path__ + "static/media/location-maps-letter-j-arrow-serr2.1c0600dd.png";